import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loginActions } from './app/store/user-login.reducer';
import { adminSettingActions } from './app/store/admin-setting.reducer';
import Routes from './app/routes';
import { NoSubscription } from './app/components/external/dashboard/no-subscription/no-subscription.component';
import Translation from './app/components/common/translation/translation.component';
import { TRANSLATIONS } from './app/utils/constant.utils';
// Ensure this path points to your new chatbot.js file
import ChatbotWidget from './app/components/common/chatbot/chatbot';
import { KyberConfigActions } from './app/store/common/chatbot/kyberconfig/kyberconfig.reducer';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasLoaded: false,
            IS_CHATBOT_DISABLED: true, // disabled by default until API check finishes
        };
    }

    async componentDidMount() {
        await this.props.getUserAuth();
        await this.props.getAdminSetting();

        this.setState(
            {
                hasLoaded: true
            },
            async () => {
                await this.refreshChatbotStatus();
            }
        );
    }

    componentDidUpdate(prevProps) {

        /*
        * NEW
        *
        * Recheck chatbot availability when login completes.
        *
        * On first load App may already be mounted while authentication
        * is still being processed. Once isLoggedIn changes from
        * false to true, check Kyber access.
        */
        if (
            !prevProps.isLoggedIn &&
            this.props.isLoggedIn
        ) {
            this.refreshChatbotStatus();
        }

        /*
        * Recheck chatbot availability whenever
        * Kyber configuration is successfully saved.
        */
        if (
            prevProps.kyberConfigLastUpdated !==
            this.props.kyberConfigLastUpdated
        ) {
            this.refreshChatbotStatus();
        }
    }

    refreshChatbotStatus = async () => {

        /*
        * UPDATED
        *
        * Do not depend on sessionStorage.User/UserId here.
        * The backend endpoint already determines the current
        * authenticated user from the logged-in user's claims.
        */

        try {
            const isKyberChatbotEnabled =
                await this.props.isKyberChatbotEnabled();

            this.setState({
                IS_CHATBOT_DISABLED:
                    !isKyberChatbotEnabled
            });
        }
        catch (error) {
            console.error(
                'Unable to check Kyber chatbot status.',
                error
            );

            this.setState({
                IS_CHATBOT_DISABLED: true
            });
        }
    };

    render() {
        if (this.state.hasLoaded) {
            return (
                <div>

                    <ChatbotWidget
                        disabled={this.state.IS_CHATBOT_DISABLED}
                    />

                    {Routes}
                </div>
            );
        }
        else {
            return (
                <div className="app-container-loading">
                    <NoSubscription
                        title={
                            <Translation
                                locale={TRANSLATIONS.defaultLocaleLanguage}
                                translationKey="loading"
                            />
                        }
                        noOverviewContainer={true}
                    />
                </div>
            );
        }
    }
}

export default connect(
    state => ({
        isLoggedIn:
            state.authentication &&
                typeof state.authentication.isLoggedIn === 'boolean'
                ? state.authentication.isLoggedIn
                : false,

        // Used to detect Kyber configuration changes.
        kyberConfigLastUpdated:
            state.kyberConfig?.lastUpdated ?? null,
    }),

    dispatch =>
        bindActionCreators(
            Object.assign(
                {},
                loginActions,
                adminSettingActions,
                KyberConfigActions
            ),
            dispatch
        )
)(App);